import { apiClient } from "@/lib/api";

const SITE = "https://decision-compass-27.emergent.host";

export function buildShareUrl(source) {
  return `${SITE}/?utm_source=${encodeURIComponent(source)}&utm_medium=share&utm_campaign=clarity_card`;
}

export function parseUtmFromLocation() {
  try {
    const sp = new URLSearchParams(window.location.search);
    return {
      utm_source: sp.get("utm_source"),
      utm_medium: sp.get("utm_medium"),
      utm_campaign: sp.get("utm_campaign"),
    };
  } catch (_) {
    return {};
  }
}

export async function track(event, extras = {}) {
  try {
    const sid = localStorage.getItem("mantrana_session_id");
    const utm = parseUtmFromLocation();
    // persist UTM once per session so we can attribute later actions
    if (utm.utm_source && !localStorage.getItem("mantrana_attribution")) {
      localStorage.setItem("mantrana_attribution", JSON.stringify(utm));
    }
    const attribution = (() => {
      try {
        return JSON.parse(localStorage.getItem("mantrana_attribution") || "{}");
      } catch (_) {
        return {};
      }
    })();
    await apiClient.post("/analytics/event", {
      event,
      session_id: sid,
      utm_source: extras.utm_source ?? attribution.utm_source ?? null,
      utm_medium: extras.utm_medium ?? attribution.utm_medium ?? null,
      utm_campaign: extras.utm_campaign ?? attribution.utm_campaign ?? null,
      consultation_id: extras.consultation_id ?? null,
      properties: extras.properties ?? null,
    });
  } catch (e) {
    // analytics must never break UX
    // eslint-disable-next-line no-console
    console.warn("analytics", event, e);
  }
}
